// reducers/videoSettingReducer.js
import { VIDEO_ACTION_TYPES } from '../actions/types'; 
// NOTE: Assuming VIDEO_ACTION_TYPES is defined here

const initialState = {
  videoSettings: [],
  videoSettingLoading: false,
  videoSettingError: null,
};

const videoSettingReducer = (state = initialState, action) => {
  switch (action.type) {
    // ==================== VIDEO SETTINGS CASES ====================
    case VIDEO_ACTION_TYPES.CREATE_VIDEO_SETTING_REQUEST:
    case VIDEO_ACTION_TYPES.GET_VIDEO_SETTINGS_REQUEST:
    case VIDEO_ACTION_TYPES.UPDATE_VIDEO_SETTING_REQUEST:
      return {
        ...state,
        videoSettingLoading: true,
        videoSettingError: null,
      };

    case VIDEO_ACTION_TYPES.CREATE_VIDEO_SETTING_SUCCESS:
      // Assuming API returns the created object
      return {
        ...state,
        videoSettingLoading: false,
        videoSettings: [...state.videoSettings, action.payload],
      };

    case VIDEO_ACTION_TYPES.GET_VIDEO_SETTINGS_SUCCESS:
      // Replaces all settings with the fetched array
      return {
        ...state,
        videoSettingLoading: false,
        videoSettings: action.payload,
      };

    case VIDEO_ACTION_TYPES.UPDATE_VIDEO_SETTING_SUCCESS:
      // Updates the specific setting by ID
      return {
        ...state,
        videoSettingLoading: false,
        videoSettings: state.videoSettings.map(setting =>
          setting.id === action.payload.id ? action.payload : setting
        ),
      };

    case VIDEO_ACTION_TYPES.CREATE_VIDEO_SETTING_FAIL:
    case VIDEO_ACTION_TYPES.GET_VIDEO_SETTINGS_FAIL:
    case VIDEO_ACTION_TYPES.UPDATE_VIDEO_SETTING_FAIL:
      return {
        ...state,
        videoSettingLoading: false,
        videoSettingError: action.payload,
      };

    // // Optional: Reset state case
    // case VIDEO_ACTION_TYPES.RESET_VIDEO_SETTING_STATE:
    //   return initialState;

    default:
      return state;
  }
};

export default videoSettingReducer;